import { render, staticRenderFns } from "./CascadingCardScaleTemplatesEditModal.vue?vue&type=template&id=4844af64"
import script from "./CascadingCardScaleTemplatesEditModal.vue?vue&type=script&lang=js"
export * from "./CascadingCardScaleTemplatesEditModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports